import { Helmet } from 'react-helmet-async';
import ClinicAddTelehealthView from 'src/sections/clinic-dashboard/therapies/therapy-add-view';

export default function ClinicAddTelehealthPage() {
  return (
    <>
      <Helmet>
        <title>Add Telehealth</title>
      </Helmet>

      <ClinicAddTelehealthView />
    </>
  );
}
